module.exports = __webpack_public_path__ + "media/images/icons/pin-14a90d38fa4ab4dd885668c14eec5926.svg";